/* Christian Al-Masoud – Shopify-Theme
   Navigation wie auf der Website + Shop-Logik (Menge, Varianten, direkt zur Kasse). */
(() => {
  const $ = (s, root = document) => root.querySelector(s)
  const $$ = (s, root = document) => [...root.querySelectorAll(s)]

  /* ---------- Navigation ---------- */
  const nav = $('[data-nav]')
  const toggle = $('[data-nav-toggle]')
  const mnav = $('[data-mobile-nav]')

  if (nav) {
    const onScroll = () => nav.classList.toggle('is-scrolled', window.scrollY > 24)
    onScroll()
    window.addEventListener('scroll', onScroll, { passive: true })
  }

  if (toggle && mnav) {
    toggle.addEventListener('click', () => {
      const open = mnav.hidden
      mnav.hidden = !open
      toggle.setAttribute('aria-expanded', String(open))
      document.body.style.overflow = open ? 'hidden' : ''
    })
  }

  /* ---------- Mengen-Stepper ---------- */
  for (const qty of $$('[data-qty]')) {
    const input = $('input', qty)
    const min = Number(input.min || 1)
    $('[data-qty-minus]', qty)?.addEventListener('click', () => {
      input.value = String(Math.max(min, Number(input.value || 0) - 1))
      input.dispatchEvent(new Event('change', { bubbles: true }))
    })
    $('[data-qty-plus]', qty)?.addEventListener('click', () => {
      input.value = String(Number(input.value || 0) + 1)
      input.dispatchEvent(new Event('change', { bubbles: true }))
    })
  }

  /* ---------- Produkt: Varianten + „Jetzt kaufen“ direkt zur Kasse ---------- */
  const form = $('[data-product-form]')
  if (form) {
    const variantsEl = $('[data-variants]', form)
    const variants = variantsEl ? JSON.parse(variantsEl.textContent) : null
    const idInput = $('[data-variant-id]', form)
    const addBtn = $('[data-add-to-cart]', form)
    const addLabel = $('[data-add-label]', form)
    const priceEl = $('[data-price-current]')
    const money = (cents) => {
      const el = document.createElement('span')
      el.textContent = (cents / 100).toLocaleString(document.documentElement.lang || 'de', {
        style: 'currency',
        currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR',
      })
      return el.textContent
    }

    if (variants) {
      const selects = $$('[data-option-select]', form)
      const sync = () => {
        const chosen = selects.map((s) => s.value)
        const v = variants.find((x) => x.options.every((o, i) => o === chosen[i]))
        if (!v) return
        idInput.value = v.id
        if (priceEl) priceEl.textContent = money(v.price)
        addBtn.disabled = !v.available
        addLabel.textContent = v.available ? addLabel.dataset.add || addLabel.textContent : 'Ausverkauft'
        const url = new URL(location.href)
        url.searchParams.set('variant', v.id)
        history.replaceState(null, '', url)
      }
      addLabel.dataset.add = addLabel.textContent
      selects.forEach((s) => s.addEventListener('change', sync))
    }

    // Permalink /cart/<variante>:<menge> ersetzt den Warenkorb und öffnet die Kasse –
    // so landen nie alte Artikel mit drin. Fallback: normales Formular (return_to=/checkout).
    form.addEventListener('submit', (e) => {
      const qty = Math.max(1, Number($('[name=quantity]', form)?.value || 1))
      if (!idInput.value) return
      e.preventDefault()
      location.href = `${(window.Shopify && Shopify.routes && Shopify.routes.root) || '/'}cart/${idInput.value}:${qty}`
    })
  }

})()
